import { createBrowserRouter, createSearchParams, generatePath } from 'react-router-dom'

import Card from '../features/card/Card'
import Cards from '../features/cards/Cards'
import CardView from '../features/cardView/CardView'
import Home from '../features/home/Home'
import NotFound from '../features/notFound/NotFound'
import Profile from '../features/profile/Profile'
import Profiles from '../features/profiles/Profiles'
import ResetPassword from '../features/resetPassword/ResetPassword'
import Root from '../features/root/Root'
import SignIn from '../features/signin/SignIn'
import SignUp from '../features/signup/SignUp'

export default createBrowserRouter([
    {
        path: "/",
        element: <Root
            signInLink={currentSearchParams => {
                const params = createSearchParams()
                if (currentSearchParams.has("redirect"))
                    params.set("redirect", currentSearchParams.get("redirect") || "")
                return ({
                    pathname: "/signin",
                    search: params.toString(),
                })
            }}
            signUpLink={currentSearchParams => {
                const params = createSearchParams()
                if (currentSearchParams.has("redirect"))
                    params.set("redirect", currentSearchParams.get("redirect") || "")
                return ({
                    pathname: "/signup",
                    search: params.toString(),
                })
            }}
            profilesLink={() => "/profiles"}
            cardsLink={() => "/cards"}
            rootLink={() => "/"} />,
        children: [
            {
                path: "",
                element: <Home />,
            },
            {
                path: "cards",
                element: <Cards
                    redirectWhenNotAuthenticated={{
                        pathname: "/signin",
                        search: createSearchParams({ redirect: "/cards" }).toString(),
                    }}
                    cardLink={cardId => ({
                        pathname: generatePath('/cards/:cardId', { cardId }),
                    })}
                    profileLink={profileId => ({
                        pathname: generatePath('/profiles/:profileId', { profileId }),
                    })}
                />,
            },
            {
                path: "cards/:cardId",
                element: <Card
                    signInLink={cardId => ({
                        pathname: "/signin",
                        search: createSearchParams({ redirect: generatePath('/cards/:cardId', { cardId }) }).toString(),
                    })}
                    signUpLink={cardId => ({
                        pathname: "/signup",
                        search: createSearchParams({ redirect: generatePath('/cards/:cardId', { cardId }) }).toString(),
                    })}
                    navigatePostRemovingFromMyCard={() => "/cards"}
                />,
                errorElement: <NotFound />
            },
            {
                path: "cards/:cardId/view",
                element: <CardView
                    redirectIfProfileLinked={profileId => ({
                        pathname: generatePath('/profiles/:profileId', { profileId }),
                        search: createSearchParams({ download: '' }).toString(),
                    })}
                    redirectIfProfileNotLinked={cardId => ({
                        pathname: generatePath('/cards/:cardId', { cardId }),
                    })} />,
                errorElement: <NotFound />
            },
            {
                path: "profiles",
                element: <Profiles
                    redirectWhenNotAuthenticated={{
                        pathname: "/signin",
                        search: createSearchParams({ redirect: "/profiles" }).toString(),
                    }}
                    profileLink={profileId => ({
                        pathname: generatePath('/profiles/:profileId', { profileId }),
                    })}
                    cardLink={cardId => ({
                        pathname: generatePath('/cards/:cardId', { cardId }),
                    })} />,
            },
            {
                path: "profiles/:profileId",
                element: <Profile
                    navigatePostDeletingProfile={() => "/profiles"}
                />,
                errorElement: <NotFound />
            },
            {
                path: "signup",
                // encodeURI is not enough, because it does not encode `+` to `%2B`
                element: <SignUp
                    redirectWhenAuthenticated={currentSearchParams =>
                        currentSearchParams.has("redirect")
                            ? currentSearchParams.get("redirect") || ""
                            : "/"
                    }
                    navigateWhenLetUserSignIn={username => ({
                        pathname: "/signin",
                        search: createSearchParams({ username }).toString(),
                    })}
                    navigateWhenLetUserResetPassword={username => ({
                        pathname: "/forgot-password",
                        search: createSearchParams({ username }).toString(),
                    })}
                    signInLink={currentSearchParams => {
                        const params = createSearchParams()
                        if (currentSearchParams.has("redirect"))
                            params.set("redirect", currentSearchParams.get("redirect") || "")
                        return ({
                            pathname: "/signin",
                            search: params.toString(),
                        })
                    }} />,
            },
            {
                path: "signin",
                element: <SignIn
                    redirectWhenAuthenticated={currentSearchParams =>
                        currentSearchParams.has("redirect")
                            ? currentSearchParams.get("redirect") || ""
                            : "/profiles"
                    }
                    signUpLink={currentSearchParams => {
                        const params = createSearchParams()
                        if (currentSearchParams.has("redirect"))
                            params.set("redirect", currentSearchParams.get("redirect") || "")
                        return ({
                            pathname: "/signup",
                            search: params.toString(),
                        })
                    }}
                    resetPasswordLink={currentSearchParams => {
                        const params = createSearchParams()
                        if (currentSearchParams.has("redirect"))
                            params.set("redirect", currentSearchParams.get("redirect") || "")
                        return ({
                            pathname: "/forgot-password",
                            search: params.toString(),
                        })
                    }} />
            },
            {
                path: "forgot-password",
                element: <ResetPassword
                    redirectWhenAuthenticated="/"
                    navigateWhenLetUserSignIn={username => ({
                        pathname: "/signin",
                        search: createSearchParams({ username }).toString(),
                    })}
                    signInLink={currentSearchParams => {
                        const params = createSearchParams()
                        if (currentSearchParams.has("redirect"))
                            params.set("redirect", currentSearchParams.get("redirect") || "")
                        return ({
                            pathname: "/signin",
                            search: params.toString(),
                        })
                    }} />,
            },
            {
                path: "*",
                element: <NotFound />
            }
        ]
    },
])
